module.exports = __webpack_public_path__ + "img/main-preview.ebc16f09.svg";